import { render, staticRenderFns } from "./addEventRules.vue?vue&type=template&id=6530c46b&scoped=true&"
import script from "./addEventRules.vue?vue&type=script&lang=ts&"
export * from "./addEventRules.vue?vue&type=script&lang=ts&"
import style0 from "./addEventRules.vue?vue&type=style&index=0&id=6530c46b&lang=scss&scoped=true&"
import style1 from "./addEventRules.vue?vue&type=style&index=1&id=6530c46b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6530c46b",
  null
  
)

export default component.exports